import OnlyHeader from "components/Layout/OnlyHeader";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  Container,
  Row,
  Button,
  Col,
  Spinner,
} from "reactstrap";
import {
  getNotifications,
  updateNotification,
  getNextNotifications,
  clearAllNotifications,
} from "store/actions/RequestActions";
import moment from "moment";
import userAvatar from "../assets/img/userAvatar.png";
import { useHistory } from "react-router-dom";
import ConfirmationModal from "components/Modals/ConfirmationModal";
import usePermissions from "hooks/usePermissions";

const AllNotifcations = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const {
    allNotifications,
    getNotificationsLoader,
    getNextLoader,
    clearAllLoader,
  } = useSelector((state) => state.requests);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const [displayCount, setDisplayCount] = useState(15);
  const { get: getAccess, edit: editAccess } = usePermissions();
  const confirmationModalToggler = () => {
    setConfirmationModal(!confirmationModal);
  };

  const handleClearAllButton = () => {
    dispatch(clearAllNotifications(user?.restaurantID)).then(() => {
      setConfirmationModal(false);
    });
  };

  const handleLoadMore = () => {
    const lastNotification = allNotifications[allNotifications.length - 1];
    dispatch(
      getNextNotifications(
        lastNotification?.restaurantID,
        lastNotification,
        (newData) => {
          if (newData.length > 0) {
            setDisplayCount(displayCount + 15);
          }
        }
      )
    );
  };

  useEffect(() => {
    dispatch(getNotifications(user?.restaurantID));
  }, [dispatch, user?.restaurantID]);

  return (
    <>
      <OnlyHeader />
      <Container fluid className="mt--7 px-3 px-md-4">
        <Row className="justify-content-center">
          <Col xs={12} xl={10} xxl={8}>
            <Card className="shadow">
              <CardHeader className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                <div className="d-flex align-items-center mb-2 mb-md-0">
                  <Button
                    size="sm"
                    color="primary"
                    onClick={() => history.push("/admin/index")}
                    className="me-3"
                  >
                    <i className="fas fa-arrow-left"></i>
                  </Button>
                  <h3 className="mb-0">Notifications</h3>
                </div>
                <div>
                  {editAccess && (
                    <Button
                      size="sm"
                      color="danger"
                      onClick={confirmationModalToggler}
                      disabled={clearAllLoader || allNotifications.length === 0}
                    >
                      {clearAllLoader ? (
                        <Spinner size="sm" color="white" />
                      ) : (
                        "Clear All"
                      )}
                    </Button>
                  )}
                </div>
              </CardHeader>
              {getNotificationsLoader ? (
                <div className="d-flex align-items-center justify-content-center py-5">
                  <Spinner size="xl" color="primary" />
                </div>
              ) : (
                <>
                  {user?.type === "kitchen-admin" ||
                  user?.type === "restaurant" ? (
                    <>
                      {getAccess || user?.type === "restaurant" ? (
                        <div className="px-3 px-md-4 py-3">
                          {allNotifications.length > 0 ? (
                            <div className="notifications-list">
                              {allNotifications
                                .slice(0, displayCount)
                                .map((notif, index) => {
                                  const timestamp = notif?.createdAt;
                                  if (
                                    !timestamp ||
                                    typeof timestamp.seconds !== "number" ||
                                    typeof timestamp.nanoseconds !== "number"
                                  ) {
                                    return null;
                                  }
                                  const unixTimestamp =
                                    timestamp.seconds * 1000 +
                                    timestamp.nanoseconds / 1000000;
                                  const date = moment.unix(
                                    unixTimestamp / 1000
                                  );
                                  const formattedDateTime =
                                    date.format("MMM DD HH:mma");
                                  return (
                                    <div
                                      key={index}
                                      className="notification-item d-flex p-3 mb-3 border rounded"
                                      style={{
                                        backgroundColor: notif?.markAsRead
                                          ? "#f8f9fa"
                                          : "#fff",
                                        border: notif?.markAsRead
                                          ? "1px solid #e9ecef"
                                          : "1px solid #dee2e6",
                                      }}
                                    >
                                      <div className="flex-shrink-0">
                                        <img
                                          src={notif?.imageURL || userAvatar}
                                          alt="User Profile"
                                          className="rounded-circle"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      </div>
                                      <div
                                        className="flex-grow-1 min-w-0"
                                        style={{ marginLeft: "10px" }}
                                      >
                                        <div className="notification-content">
                                          <p
                                            className="mb-1 text-wrap"
                                            style={{ fontSize: "14px" }}
                                          >
                                            <strong>{notif?.name}</strong>{" "}
                                            {notif?.message}
                                          </p>
                                          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center">
                                            <small
                                              className="text-muted mb-2 mb-sm-0"
                                              style={{ fontSize: "12px" }}
                                            >
                                              {formattedDateTime}
                                            </small>
                                            {(editAccess ||
                                              user?.type === "restaurant") &&
                                              notif?.markAsRead !== true && (
                                                <Button
                                                  size="sm"
                                                  color="primary"
                                                  onClick={() =>
                                                    dispatch(
                                                      updateNotification(
                                                        user?.restaurantID,
                                                        notif.id
                                                      )
                                                    )
                                                  }
                                                  className="flex-shrink-0"
                                                >
                                                  Mark as Read
                                                </Button>
                                              )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                })}
                            </div>
                          ) : (
                            <div className="text-center py-5">
                              <p className="text-muted mb-0">
                                No Notifications
                              </p>
                            </div>
                          )}
                          {(getAccess || user?.type === "restaurant") &&
                            allNotifications.length >= displayCount && (
                              <div className="text-center mt-4">
                                <Button
                                  onClick={handleLoadMore}
                                  disabled={getNextLoader}
                                  color="primary"
                                  size="md"
                                >
                                  {getNextLoader ? (
                                    <Spinner size="sm" color="white" />
                                  ) : (
                                    "Load More"
                                  )}
                                </Button>
                              </div>
                            )}
                        </div>
                      ) : (
                        <div className="text-center py-5">
                          <p className="text-muted mb-0">
                            You don't have the permission to access this page
                          </p>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="text-center py-5">
                      <p className="text-muted mb-0">
                        You don't have the permission to access this page
                      </p>
                    </div>
                  )}
                </>
              )}
            </Card>
          </Col>
        </Row>
        <ConfirmationModal
          title="Clear All Notifications"
          text="Are you sure you want to delete all notifications?"
          isOpen={confirmationModal}
          toggle={confirmationModalToggler}
          isLoading={clearAllLoader}
          onConfirmation={handleClearAllButton}
        />
      </Container>
    </>
  );
};

export default AllNotifcations;
